module.exports = __webpack_public_path__ + "static/media/profile.03902e01.jpg";